:host * {
  background-color: var(--dark-blue-702-main-menu);
}

.intro {
  color: var(--white-layout-250-disabled-text-on-blue-background);
}

.is-loading {
  gz-progress-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  gz-list-item,
  .header-actions {
    display: none;
  }
}

gz-progress-spinner {
  display: none;
}

gz-tooltip[class='userName'] {
  display: block;
}

.username {
  display: inline;
}

.top {
  padding: var(--spacer) calc(2 * var(--spacer));
  border-bottom: 1px solid var(--white-layout-010-hover-primary);
}

.bottom {
  --item-padding: 0 16px;

  border-top: 1px solid var(--white-layout-010-hover-primary);
  height: calc(var(--spacer) * 5);
  display: flex;
  align-items: center;
}

.left {
  line-height: 1.2;
  max-width: calc(100% - var(--spacer) * 7.5);
}

gz-text,
gz-list-item {
  font-size: var(--body-size-large);
  color: var(--white-layout-300-primary);
}

gz-list-item {
  --item-padding: calc(var(--spacer) / 2) calc(2 * var(--spacer));
  --text-color: var(--white-layout-300-primary);
  --active-background-color: var(--white-layout-050-hover-on-dark-background);
  --hover-background-color: var(--white-layout-005-background-for-icon-menu);
}

.header-action {
  padding: calc(var(--spacer) / 2) calc(2 * var(--spacer));
  cursor: default;
  align-items: center;

  .theme-button {
    border: transparent;
    background-color: transparent;
    color: var(--white-layout-300-primary);
    position: relative;
    width: calc(3 * var(--spacer));
    height: calc(3 * var(--spacer));
    cursor: pointer;
    padding: 0;
    &:not(.high-contrast) {
      margin-right: calc(var(--spacer) / 4);
    }

    &:hover {
      .theme-button-icon {
        background-color: var(--white-layout-050-hover-on-dark-background);
      }
    }

    &.active {
      gz-icon::part(svgIcon) {
        fill: var(--blue-layout-301-active);
      }
    }

    &:focus-visible {
      outline: 2px solid var(--blue-layout-504-focus-on-dark-background-light-theme) !important;
      background-color: var(--chart-304-icon-buttons);
      border-radius: 4px;
    }
    .theme-button-icon {
      line-height: 1;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.3s ease 0s, color 0.3s ease 0s;
      border-radius: 4px;
    }
  }
}

gz-font-size-changer {
  width: auto;
}

gz-toggle {
  --margin-vertical: 0;
  --label-padding-left: 0;
  --checked-bar-color: #90befdb2;

  width: auto;
}
